require('core-js/features/promise/any')
import Chatbot from './loader/Chatbot'

window.noci = window.noci || {}

if (window.noci.chatbot === undefined) {
  window.noci.chatbot = new Chatbot()
  window.noci.initialized = false

  window.addEventListener('load', () => {
    if (window.noci.initialized)
      return
    window.noci.initialized = true
    window.noci.chatbot.init()
  }, false)

  window.noci.initializationInterval = setInterval(_ => {
    if (window.noci.initialized) {
      clearInterval(window.noci.initializationInterval)
      return
    }

    if (document.readyState !== "complete")
      return

    window.noci.initialized = true
    clearInterval(window.noci.initializationInterval)
    window.noci.chatbot.init()
  }, 1000)
}
